"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("@alycecom/utils");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    wrapper: {
      display: 'flex',
      flexWrap: 'nowrap'
    },
    imageWrapper: {
      flex: '0 0',
      marginRight: spacing(0.5),
      display: 'flex',
      alignItems: 'center'
    },
    label: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    flagImage: {
      width: 18,
      height: 18
    }
  };
});

var SingleSelectedCountryOption = function SingleSelectedCountryOption(_ref2) {
  var _ref2$classes = _ref2.classes,
      externalClasses = _ref2$classes === void 0 ? {} : _ref2$classes,
      name = _ref2.name,
      flag = _ref2.flag;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.wrapper, externalClasses.wrapper)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.imageWrapper, externalClasses.imageWrapper)
  }, flag && (0, _utils.isValidImage)(flag) && /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _classnames.default)(classes.flagImage, externalClasses.flagImage),
    src: flag,
    alt: "Country flag"
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.label, externalClasses.label),
    component: "span"
  }, name));
};

var _default = /*#__PURE__*/(0, _react.memo)(SingleSelectedCountryOption);

exports.default = _default;